<div [innerHTML]="config.data.message"></div>
<div class="mt-25 flex justify-between">
  <p-button [label]="config.data.cancelButtonText" severity="secondary" (click)="onCancel()"/>
  <p-button [label]="config.data.confirmButtonText" (click)="onConfirm()" [severity]="config.data.confirmButtonSeverity"/>
</div>